<template>
    <section :title="description" v-if="capture || unavailable" class="meeting-recording-status" role="status" aria-live="polite">
        <div class="meeting-recording-symbol" aria-hidden="true">{{ capture?.status === 'processing' ? '◷' : '●' }}</div>
        <div class="meeting-recording-copy"><h2>{{ title }}</h2><span v-if="capture?.status === 'processing' && capture.stage">{{ capture.stage }}</span></div>
        <router-link v-if="capture" :to="'/ai-review/' + capture.jobId">{{ capture.status === 'processing' ? 'View progress' : capture.notesReady ? 'View notes & transcript' : 'Open recording' }}</router-link>
        <button v-else @click="load">Try again</button>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
export default defineComponent({
    name: 'AIMeetingStatus', props: ['meetingId'],
    data() { return { capture: null as any, unavailable: false, timer: null as any, version: 0, gone: false }; },
    computed: {
        title(): string {
            if (this.unavailable) return 'Recording status unavailable';
            return ({ recording: 'Recording in progress', processing: 'Recording processing', complete: 'Notes ready', consumed: 'Notes saved', error: 'Recording needs attention' } as any)[this.capture?.status] || 'Meeting recording';
        },
        description(): string {
            if (this.unavailable) return 'We could not check the recording. Try again in a moment.';
            if (this.capture?.status === 'processing') return 'Your recording is saved. We are preparing the transcript and meeting notes. You can leave this page and come back later.';
            if (this.capture?.status === 'recording') return 'The recording has not been submitted yet. Keep the recording tab open until you stop and save it.';
            if (this.capture?.status === 'error') return 'Open the recording to review the issue and retry processing.';
            return 'Open the recording, speaker transcript and notes for this meeting.';
        }
    },
    watch: { meetingId: { immediate: true, handler() { this.capture = null; this.load(); } } },
    unmounted() { this.gone = true; this.version++; if (this.timer) clearTimeout(this.timer); },
    methods: {
        async load() {
            if (this.timer) clearTimeout(this.timer);
            const version = ++this.version, meetingID = Number(this.meetingId);
            if (!meetingID || this.gone) return;
            try {
                const capture = (await axios.get(`${this.$store.state.apiUrl}/api/ai/meeting-capture-status`, { params: { meetingID } })).data;
                if (version !== this.version || this.gone) return;
                this.capture = capture; this.unavailable = false;
            } catch { if (version === this.version && !this.gone) this.unavailable = true; }
            if (version === this.version && !this.gone) this.timer = setTimeout(() => this.load(), 5000);
        }
    }
});
</script>
<style scoped>
.meeting-recording-status { display:flex; align-items:center; justify-content:flex-start; flex-wrap:wrap; gap:5px 9px; max-width:100%; color:#51463b; font-size:12px; margin-bottom:8px; }
.meeting-recording-symbol { color:#f4ae57; font-size:12px; }
.meeting-recording-copy h2 { font-size:12px; margin:0; font-weight:600; color:#51463b; }
.meeting-recording-copy span { display:block; font-size:11px; max-width:240px; }
.meeting-recording-status a,.meeting-recording-status button { color:#a64010; font-size:12px; font-weight:600; text-decoration:underline; background:none; border:0; padding:0; cursor:pointer; }
</style>
